import React, {Suspense, lazy} from 'react';
import {ROUTE_ADMIN_LOGIN_AS} from '../../RoutePathConstant';
import {Spin} from 'antd';
import {authLoader} from '../../loader';

const LoginAs = lazy(() =>
  import('../../../screens/LoginAs')
    .then(module => ({default: module.LoginAs})));

const LoginAsNavigation = [
  {
    path: ROUTE_ADMIN_LOGIN_AS,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <LoginAs />
      </Suspense>
    ),
  }];

export default LoginAsNavigation;
